<div id="activity-info-page">
    <div class="page-section">
        <div class="page-section-header">
            <h2 translate>User Activity</h2>
        </div>
        <div class="page-section-content">
            <activity-listing [isActivityTabEnabled]="isActivityTabEnabled"></activity-listing>
        </div>
    </div>
</div>